<template>
    <div class="member-import">
        <bread-crumb :list="[{
            text: '会员管理',
            url: '/main/member/nav/memberList'
        }, {
            text: '会员导入'
        }]"/>
        <!-- 店铺导入 表格导入 -->
        <div class="fx-v-center fx-h-between">
            <tabs v-model="activeTabName" :tabs="tabs" :disabled="$store.state.shop.isImportingMemberData" @tab-click="handleTabClick" />
            <span class="href fs-14" @click="isShowImportRecord = true">导入记录</span>
        </div>
        <router-view class="router-view" />
        <!-- components -->
        <import-record :visible.sync="isShowImportRecord" />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, computed, watch } from '@vue/composition-api'
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import Tabs from '@/components/tabs/tabs.vue'
import ImportRecord from './components/import_record.vue'
import { routerUtil } from '@/utils/routerUtil'
import { openNotifyIsImporting } from '../../../components/notify_is_importing/notify_is_importing'

export default createComponent({
    setup: (props, ctx) => {
        
        const isImporting = ref(false)
        const isShowImportRecord = ref(false)
        const store = ctx.root.$store
        const tabs = computed(() => [1235, 1171, 771, 1263, 1293, 1300, 1268].includes(store.state.shop.shopInfo.id)
            ?    [
                    {
                        name: '店铺导入',
                        paneName: 'shopImport'
                    },
                    {
                        name: '表格导入',
                        paneName: 'tableImport'
                    }
                ]
            :
                [
                    {
                        name: '表格导入',
                        paneName: 'tableImport'
                    }
                ]
        )
        ctx.root.$router.push({
            path: [1235, 1171, 771, 1263, 1293, 1300, 1268].includes(store.state.shop.shopInfo.id) ? '/main/member/memberImport/shopImport' : '/main/member/memberImport/tableImport'
        })

        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        return {
            isImporting,
            isShowImportRecord,
            tabs,
            activeTabName,
            handleTabClick
        }
    },

    components: {
        BreadCrumb,
        Tabs,
        ImportRecord
    }
})
</script>

<style lang="scss" scoped>
.router-view {
    margin-top: 12px;
}
</style>
